import { styled } from '@mui/material/styles'

export const Title = styled('span')({
  fontWeight: 'bold',
  textAlign: 'right',
})
